module.exports = __webpack_public_path__ + "media/images/prescription-logo-d592ab2dd4d471d08c4e8814aefc36cd.svg";